import { BrowserRouter } from 'react-router-dom';

import { Toaster } from '@/components/ui/sonner';

import AppRoutes from '@/routes';

const App = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster position='top-center' />
    </BrowserRouter>
  );
};

export default App;
